import { useLocation } from "react-router-dom";
import PageMeta from "@/components/PageMeta/PageMeta";
import { getJsonLdForPath, getSeoForPath } from "@/content/seo";

export default function SeoRoute() {
  const { pathname } = useLocation();
  const seo = getSeoForPath(pathname);
  const jsonLd = getJsonLdForPath(pathname);

  return <PageMeta {...seo} jsonLd={jsonLd} />;
}
